// extracted by mini-css-extract-plugin
module.exports = {"link":"V5qIkUZQ26q8BxYFHabcf"};